import { categoryConst } from "../constants/categoryConst";

const categoryDetailReducer = (state = [], action) => {
  switch (action.type) {
    case categoryConst.VIEW_CATEGORY_DETAIL:
      return {
        loading: true
      };
    case categoryConst.VIEW_CATEGORY_DETAIL_SUCCESS:
      return {
        items: action.category
      };
    case categoryConst.VIEW_CATEGORY_DETAIL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
};
export default categoryDetailReducer;



// WEBPACK FOOTER //
// ./src/app/redux/reducers/categoryDetailReducer.js